import * as types from '../actions/actionTypes';
import initialState from './initialState';     
        
export default function comentariosReducer(state= initialState.comentarios, action){
    let newState;
	switch(action.type){
         case types.LOAD_COMENTARIOS_LIST_SUCCESS:		
            action.comentarios.filtroActivo=state.filtroActivo;
            action.comentarios.filtroActual=state.filtroActual;
            action.comentarios.showActivos=state.showActivos;
			 action.comentarios.paginaActual=action.comentarios.pageable.pageNumber;
			 action.comentarios.registrosPorPagina=action.comentarios.size;
            
            return action.comentarios;

        case types.BORRAR_COMENTARIOS_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(comentarios => comentarios.id !== action.comentarios.id)];          
			return newState;    
            
        case types.ACTIVAR_COMENTARIOS_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(comentarios => comentarios.id !== action.comentarios.id)];          
			 return newState;
            
        case types.SET_FILTRO_COMENTARIOS:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}